import React, { useState, useEffect } from "react";
import PaywallUtils from "Utils/PaywallUtils";
import Utils from "Utils/utils";
import userDetail from "Stores/userDetail";
import DropdownMenu from "Components/common/DropDownMenu";
import { ReactComponent as CvsExportIcon } from "Assets/svg/csvExport.svg";
import { SEQUENCE_STAGE_ICON } from "Model/model";
import { deepResearchStepPopupState } from "Pages/Dashboard/sequences/Stages/DeepResearchStepPopupState";
import { hasDeepResearchStep } from "Pages/Dashboard/sequences/Stages/deepResearchAware";

const AddStageDropDown = ({
  showDropDownMenu,
  setShowDropDownMenu,
  defaultSelected = "email",
  steps = {},
  stepLen = 0,
  considerStepLen = false,
  cbk = () => {},
  isTaskCreation = false,
  className = ""
}) => {
  const drAlreadyExists = hasDeepResearchStep(steps);
  const {
    taskEnabled = false,
    planName = "",
    inFreePlan = false,
    liAutomationEnabled = false
  } = userDetail?.userFeatureFlag || {};

  const handleClick = (key = "", dropDownObj = {}) => {
    setShowDropDownMenu(false);

    // Deep Research step opens its own dedicated config popup (separate from the
    // standard email/LinkedIn/Phone/CustomTask flow handled by `cbk`).
    if (dropDownObj?.key === "deepResearch") {
      deepResearchStepPopupState.setPopupValues({
        currentStep: stepLen + 1,
        isEdit: false,
        existingConfig: null,
        onSave: (savedStep) => {
          // Hand off to the normal sequence-builder save callback so the parent
          // can persist the new step. The parent receives the same dropDownObj
          // shape it expects, plus the DR config attached.
          cbk({ ...dropDownObj, drConfig: savedStep.config });
        }
      });
      deepResearchStepPopupState.setShowPopup(true);
      return;
    }

    if (dropDownObj?.showUpgrade) {
      if (dropDownObj?.key?.toLowerCase() === "linkedinauto") {
        PaywallUtils.upgradeUtilsFunction(
          "sequenceLinkedInAddToSequence",
          true,
          planName,
          inFreePlan
        );
      } else {
        PaywallUtils.upgradeUtilsFunction(
          "sequenceAddTaskToSequence",
          true,
          planName,
          inFreePlan
        );
      }
    } else {
      cbk(dropDownObj);
    }
  };

  const NEW_BADGE_HTML =
    '<span style="margin-left:8px;padding:1px 6px;font-size:10px;font-weight:600;letter-spacing:0.4px;color:#fff;background:linear-gradient(90deg,#7c3aed,#3b82f6);border-radius:8px;vertical-align:middle;">NEW</span>';

  const drFeatureOn = Utils.isSequenceDRFeatureEnabled();

  const stepOptions = [
    // Deep Research step is gated by the sequence-DR feature flag. Hide
    // entirely when off so reps can't even pick it.
    ...(drFeatureOn
      ? [
          {
            icon: {
              ele: SEQUENCE_STAGE_ICON["deepResearch"]
            },
            // Hide the NEW badge once DR is already in the sequence — no point
            // marketing a feature the rep has already adopted, and the badge
            // wraps awkwardly next to a "Added" sublabel on a single row.
            value: drAlreadyExists ? "Deep Research" : `Deep Research${NEW_BADGE_HTML}`,
            key: "deepResearch",
            method: handleClick,
            planName: PaywallUtils.getPlanName(planName, inFreePlan),
            type: "sequenceAddTaskToSequence",
            disabled: drAlreadyExists,
            hasSubLabel: drAlreadyExists,
            subLabel: drAlreadyExists ? "✓ Added" : ""
          }
        ]
      : []),
    {
      ...(!isTaskCreation && {
        icon: {
          ele: SEQUENCE_STAGE_ICON["email"]
        },
        value: "Email (Automatic)",
        key: "email",
        method: handleClick,
        planName: PaywallUtils.getPlanName(planName, inFreePlan),
        type: "sequenceAddTaskToSequence"
      })
    },
    {
      icon: {
        ele: SEQUENCE_STAGE_ICON["manualEmail"]
      },
      value: "Email (Manual)",
      key: "manualEmail",
      method: handleClick,
      planName: PaywallUtils.getPlanName(planName, inFreePlan),
      type: "sequenceAddTaskToSequence",
      showUpgrade: !taskEnabled
    },
    {
      ...(!isTaskCreation && {
        icon: {
          ele: SEQUENCE_STAGE_ICON["linkedin"]
        },
        value: "LinkedIn (Automatic)",
        key: "linkedinAuto",
        method: handleClick,
        planName: PaywallUtils.getPlanName(planName, inFreePlan),
        type: "sequenceAddTaskToSequence",
        showUpgrade: !liAutomationEnabled
      })
    },
    {
      icon: {
        ele: SEQUENCE_STAGE_ICON["linkedin"]
      },
      value: "LinkedIn (Manual)",
      key: "linkedin",
      method: handleClick,
      planName: PaywallUtils.getPlanName(planName, inFreePlan),
      type: "sequenceAddTaskToSequence",
      showUpgrade: !taskEnabled
    },
    {
      icon: {
        ele: SEQUENCE_STAGE_ICON["phone"]
      },
      value: "Call",
      key: "phone",
      method: handleClick,
      planName: PaywallUtils.getPlanName(planName, inFreePlan),
      type: "sequenceAddTaskToSequence",
      showUpgrade: !taskEnabled
    },
    {
      icon: {
        ele: SEQUENCE_STAGE_ICON["customTask"]
      },
      value: "Custom Task",
      key: "customTask",
      method: handleClick,
      planName: PaywallUtils.getPlanName(planName, inFreePlan),
      type: "sequenceAddTaskToSequence",
      showUpgrade: !taskEnabled
    }
  ].filter(value => Object.keys(value).length !== 0);

  return (
    <div className={className}>
      {showDropDownMenu && (
        <>
          <DropdownMenu
            options={stepOptions}
            direction={
              considerStepLen ? (stepLen > 1 ? "bottomAlign" : "") : ""
            }
          />
          <div
            className="dropdownMask"
            onClick={e => setShowDropDownMenu(false)}
          />
        </>
      )}
    </div>
  );
};

export { AddStageDropDown };
export default AddStageDropDown;
